import React from 'react'
import { loginUrlWithQuery } from 'helpers/format'

export default props => {
  return (
    <div className="signup-box signup-box__new-account">
      <div className="row">
        <div className="signup-box__new-account-txt col-sm-12">
          <a
            href={loginUrlWithQuery(props.config.URL)}
            className="signup-box__new-account-title"
          >
            {i18n.t('page.account.l_00037')}
            <span className="signup-box__new-account-linktxt">ログイン</span>
            <i className="fas fa-angle-right" />
          </a>
        </div>
      </div>
    </div>
  )
}
